import { buildModule } from '../utils';

import detail from './detail';

export default buildModule()
	.withSubmodules({
		detail,
	});
